import { Route, Routes } from 'react-router-dom'
import { AuthPage } from './auth/AuthPage'
import { ProfilePage } from './auth/Profile'
import { ExamBlockPage } from './modes/ExamBlock'
import { DrillPage } from './modes/Drill'
import { HomePage } from './pages/Home'
import { PreviewPage } from './pages/Preview'
import { StatsDashboard } from './stats/Dashboard'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/drill" element={<DrillPage />} />
      <Route path="/exam" element={<ExamBlockPage />} />
      <Route path="/stats" element={<StatsDashboard />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/register" element={<AuthPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/preview" element={<PreviewPage />} />
    </Routes>
  )
}
